<template>
<div>
    <!-- Start Checklist DIV -->
    <div ref="checklist">

    <div v-for="category in categories" :key="category.meta.key" style="xxxxxbackground-color: #fafafa;max-width:800px">

        <!-- Category heading and menu -->
        <v-menu offset-y class="full-width">
            <template v-slot:activator="{ on }">
            <div v-on="on" v-if="!clientOrEmail" @dblclick="editCategory(category)" class="section-heading full-width hoverable">
                {{category.name}}
            </div>
            </template>
            <v-list>
                <v-list-item @click="$emit('add-category-document', category)">
                    <v-list-item-title>Add {{category.name}} Document</v-list-item-title>
                </v-list-item>
                <v-list-item @click="deleteCategory(category)">
                    <v-list-item-title>Delete Category</v-list-item-title>
                </v-list-item>
                <v-list-item @click="sortCategories">
                    <v-list-item-title>Sort Categories</v-list-item-title>
                </v-list-item>
                <v-list-item @click="addCategory">
                    <v-list-item-title>Add Another Category</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        
        <div v-for="policy in policiesForCategory(category)" :key="policy.meta.key" class="item-pulse">

            <!-- Policy heading and menu -->
            <v-menu offset-y :disabled="clientOrEmail" class="xxxxdisplay-block hoverable">
                <template v-slot:activator="{ on }">
                <div v-on="on" @dblclick="editPolicy(policy)" style="font-size:20px;color:#1976d2;padding:2px 5px;">{{policy.name}}</div>
                </template>
                <v-list>
                    <v-list-item @click="editPolicy(policy)">
                        <v-list-item-title>Edit this Policy</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="sortPoliciesForCategory(category)">
                        <v-list-item-title>Sort {{category.name}} Policies</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="deletePolicy(policy)">
                        <v-list-item-title>Delete this Policy</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu> 
            <br>

            <!-- Options (active one) -->
            <template v-if="firstOptionForPolicy(policy).name" >
                <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                    <b v-on="on" v-if="mode == 'Template'" style="padding:2px 5px;" class="hoverable" @dblclick="editOption(firstOptionForPolicy(policy))">{{firstOptionForPolicy(policy).name}}</b>
                    </template>
                    <v-list>
                        <v-list-item @click="editOption(firstOptionForPolicy(policy))">
                            <v-list-item-title>Edit this Option</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="sortOptionsForPolicy(policy)">
                            <v-list-item-title>Sort {{policy.name}} Options</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="deleteOption(firstOptionForPolicy(policy))">
                            <v-list-item-title>Delete this Option</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <template v-for="document in documentsForOption(firstOptionForPolicy(policy))">
                    <!-- Documents -->
                    <div style="float:right;margin-top:10px" class="no-print" :key="'d-' + document.meta.key">
                        
                        <v-menu v-if="!clientOrEmail" v-model="document.meta.menuOpen" :close-on-content-click="false"  bottom>
                            <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on"><v-icon >keyboard_arrow_down</v-icon></v-btn>
                            </template>
                            <div v-if="mode=='Consultant'" class="pa-3 white-background">
                                <v-switch class="compact" hide-details color="green" v-model="document.received" @change="switchReceived(document)" label="Received"></v-switch>
                            </div>
                            <div @click="document.meta.menuOpen = false">
                                <v-list>
                                    <v-list-item @click="addDocument(firstOptionForPolicy(policy).meta.key)">
                                        <v-list-item-title>Add Document Here</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="$emit('add-category-document', category)">
                                        <v-list-item-title>Add Different {{category.name}} Doc</v-list-item-title>
                                    </v-list-item>
                                    <v-divider/>
                                    <v-list-item @click="editDocument(document)">
                                        <v-list-item-title>Edit Document</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="sortDocumentsForOption(firstOptionForPolicy(policy))" v-if="documentsForOption(firstOptionForPolicy(policy)).length > 1">
                                        <v-list-item-title>Sort Documents</v-list-item-title>
                                    </v-list-item>
                                    <v-divider/>
                                    <v-list-item @click="deleteDocument(document)">
                                        <v-list-item-title>Delete Document</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="deleteOption(firstOptionForPolicy(policy))">
                                        <v-list-item-title>Delete Entire Option</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </div>
                        </v-menu>
                    </div>
               
                    <ChecklistDocument :document="document" :pageSettings="pageSettings" @open="editDocument" :key="document.meta.key"/>
                </template>
                <div v-if="mode == 'Template'">
                    <a href @click.prevent.stop="addDocument(firstOptionForPolicy(policy).meta.key)">Add a Document</a>&nbsp;
                </div>
            </template>

            <!-- Remaining Options -->
            <div v-if="(optionsForPolicy(policy).length > 1) && mode != 'Email'" class="mb-3">
                <span>Other Options: </span>
                <span v-for="(option, index) in remainingOptionsForPolicy(policy)" :key="index + 1">
                    <a href @click.prevent.stop="optionLinkClicked(option)">{{option.name}}</a>&nbsp;&nbsp;
                </span>
            </div>
            <div v-if="(optionsForPolicy(policy).length > 1) && mode == 'Email'" class="mb-3" style="color:#888">
                There are other options available for this one. Go to the online checklist and you can switch between them.
            </div>
            <span v-if="mode == 'Template'">
                <a href @click.prevent.stop="addOption(policy.meta.key)">Add an Option</a>&nbsp;
            </span>
        </div>
        <div v-if="mode == 'Template'">
            <a href @click.prevent.stop="addPolicy(category.name)">Add a Policy</a>&nbsp;
        </div>
    </div>
    <div v-if="mode == 'Template'">
        <a href @click.prevent.stop="addCategory">Add a Category</a>&nbsp;
    </div>

    </div> 
    <!-- End Checklist DIV -->
    <AdvancedDialog :record="editDialog.record" :settings="editDialog.settings" :fields="editDialog.fields" @save="saveRecord" @delete="deleteRecord" @menu="editDialogMenu"/>
    <!-- <AdvancedDialog :record="deleteDialog.record" :settings="deleteDialog.settings" :fields="deleteDialog.fields" @save="saveRecord" @delete="deleteRecord"/> -->
    <SortDialog :items="sortDialog.items" :dataRef="sortDialog.dataRef" :settings="sortDialog.settings" />
    <!-- <DialogBox title="New Document" :settings="settings" @save="saveNewDocument" @xxshow="show"> -->
    <!-- </DialogBox> -->
    
    
</div>
</template>

<script>
import DataHelpers from '../../helpers/DataHelpers'
import NiceData from '../../data/NiceData'
import AdvancedDialog from '../../ui-elements/AdvancedDialog'
import SortDialog from '../../ui-elements/SortDialog'
import ChecklistDocument from './ChecklistDocument'
import OrderHelpers from '../../helpers/OrderHelpers'
import DialogBox from '../../ui-elements/DialogBox'
import StringHelpers from '../../helpers/StringHelpers';
import PageHelpers from '../../helpers/PageHelpers';
import ChecklistHelpers from './ChecklistHelpers';
import FirebaseHelpers from '../../helpers/FirebaseHelpers';



export default {
    data() {
        return {
            
            categories: [],
            policies: [],
            options: [],
            documents: [],

            categoriesString: null,

            sortDialog: {
                settings: {
                    visible:false,
                    title: 'Sort Items',
                    closeOnly: true,
                },
                dataRef: null,
                items: null,
            },

            // deleteScreenFields: [
            //     {name: 'deleteType', title: 'Delete the following', type: 'Options', options:["Just this document", "This option", "This whole policy"]},
            // ],

            categoryFields: [
                {name: 'name', title: 'Name', type: 'Text'},
            ],
            optionFields: [
                {name: 'name', title: 'Name', type: 'Text'},
            ],

            documentFields: [
                {name: 'name', title: 'Name', type: 'Text'},
                {name: 'messageToClient', title: 'Message to Client', type: 'Text', clearable: true, visibleFilter: (this.mode != 'Template')},

                {name: 'received', title: 'Received', type: 'Switch', visibleFilter: (this.mode != 'Template')},
                {name: 'checks', title: 'Things to Check', type: 'Group', disabled: (this.mode == 'Client'), fields: [
                    {name: 'check', title: 'Check', type: 'Text', rows:2, width:70, clickToEdit:true},
                    {name: 'complete', title: 'Complete', type: 'Checkbox', width:10, visibleFilter: (this.mode != 'Template'), compact:true}
                ]},
                {name: 'attachment', title: 'Attach File', type: 'File', color:'primary'},
                {name: 'links', title: 'Associated Links', type: 'Group', fields: [
                    {name: 'url', title: 'Link URL', type: 'Text'},
                    {name: 'display', title: 'Display Text', type: 'Text'}
                ]},      
                {name: 'date', title: 'Document Date', type: 'Date', visibleFilter: (this.mode != 'Template')},
                {name: 'information', title: 'More Information', type: 'Embed', disabled: (this.mode != 'Template')},


            ],
            openDocumentFields: [
                {name: 'name', title: 'Name', type: 'Html', disabled: true},
                {name: 'checks', title: 'Things to Check', type: 'Group', disabled:true, fields: [
                    {name: 'check', title: 'Please Check', type: 'Html', width:70},
                    {name: 'complete', title: 'Confirmed', type: 'Checkbox', width:10, compact:true}
                ]},
                {name: 'attachment', title: 'Attach File', type: 'File', color:'primary'},
                {name: 'date', title: 'Document Date', type: 'Date'},

                {name: 'information', title: 'More Information', type: 'Embed', disabled:true},

            ],

            editDialog: {
                record: {},
                settings: {
                    visible: false
                },
                fields: [], 
            }            
        }
    },

    components: {
        AdvancedDialog,
        SortDialog,
        ChecklistDocument,
        DialogBox,
    },
    
    props: {
        transactionKey: String,
        checklistKey: String,
        mode: {
            type: String,           //can be 'Client', 'Consultant' or 'Template'
            default: 'Client'
        },
        pageSettings: {
            type: Object,
            default: function() {return {}}
        } 
    },

    computed: {
        summary() {
            return {
                documents: this.documents.length,
                received: this.documents.filter(o => o.received).length,
                outstanding: this.documents.filter(o => !o.received && !o.attachment).length
            }
        },

        policyFields() {
            return [
                {name: 'debugPolicyMenu', title: 'Debug Policy', type: 'Menu'},
                {name: 'name', title: 'Name', type: 'Text'},
            ]
        },

        clientOrEmail() {
            return this.mode == 'Client' || this.mode == 'Email'
        },

        imagePath() {
            return StringHelpers.imagePath()
        },

        checklistRef() {
            return DataHelpers.getRootRef().child('app/documentChecklist/data').child(this.checklistKey)
            if(this.transactionKey)
                return DataHelpers.getTenantRef().child('documentChecklist')
                //return DataHelpers.getTenantRef().child('transactions').child(this.transactionKey).child('checklist')
            else
                return null
        },
        categoriesRef() {
            return this.checklistRef.child('categories')
        },
        policiesRef() {
            return this.checklistRef.child('policies')
        },
        optionsRef() {
            return this.checklistRef.child('options')
        },
        documentsRef() {
            return this.checklistRef.child('documents')
        },


        policiesString() {
            return this.categories.map(o => o.name).join(',')
        },


  

    },

    methods: {
        editDialogMenu({menu, record}) {
            console.log('edit dialog menu', menu, record)
            if(menu.name == 'debugPolicyMenu') {
                let policyKey = record.meta.key
                let checklistKey = this.checklistKey
                let path = 'app/documentChecklist/data/' + checklistKey + '/policies/' + policyKey
                FirebaseHelpers.viewInConsole(path)
            }

        },

        indicatorColour(document) {
            if(document.received)
                return "green"
            if(!document.received && this.pageSettings.flagOutstandings)
                return "red"
            return "grey"
        }, 
        switchReceived(document) {
            NiceData.saveItem(document)
        },
        loadCategories() {
            let vm = this
            this.categoriesRef.orderByChild('order').on('value', snap => {
                this.categories = NiceData.arrayFromSnapshot(snap)
                this.categoriesString = this.categories.map(o => o.name).join(',')
            })
        },
        loadPolicies() {
            this.policiesRef.orderByChild('order').on('value', snap => {
                this.policies = NiceData.arrayFromSnapshot(snap)
                this.$store.commit('setSelectedKeys', {code: 'checklist-policies', keys: this.policies.map(o => o.name)})
            })
        },
        loadOptions() {
            this.optionsRef.orderByChild('order').on('value', snap => {
                this.options = NiceData.arrayFromSnapshot(snap)
            })
        },
        loadDocuments() {
            this.documentsRef.orderByChild('order').on('value', snap => {
                this.documents = NiceData.arrayFromSnapshot(snap)
            })
        },

        addCategory() {
            let category = NiceData.makeItem(this.categoriesRef)
            category.meta.savePosition = "top"
            this.editCategory(category)
        },
        addPolicy(categoryName) {
            let policy = NiceData.makeItem(this.policiesRef)
            policy.category = categoryName
            policy.meta.savePosition = "top"
            this.editPolicy(policy)
        },
        addOption(policyKey) {
            let option = NiceData.makeItem(this.optionsRef)
            option.policyKey = policyKey
            option.meta.savePosition = "top"
            this.editOption(option)
        },
        addDocument(optionKey) {
            let document = NiceData.makeItem(this.documentsRef)
            document.optionKey = optionKey
            document.meta.savePosition = "top"
            this.editDocument(document)
        },

        addDifferentDocument(document) {
            this.editDialog.fields = this.differentDocumentFields
            this.editDialog.settings.mode = 'different'
            this.editDialog.settings.title = 'Different Document'
            this.editDialog.settings.deleteButton = false
            this.editDialog.settings.visible = true
        },

        editCategory(category) {
            this.editDialog.fields = this.categoryFields
            this.editDialog.record = {...category}
            this.editDialog.settings.visible = true
        },
        editPolicy(policy) {
            this.editDialog.fields = this.policyFields
            this.editDialog.record = {...policy}
            this.editDialog.settings.title = 'Policy Details'
            this.editDialog.settings.visible = true
        },
        editOption(option) {
            this.editDialog.fields = this.optionFields
            this.editDialog.record = {...option}
            this.editDialog.settings.title = 'Option - ' + (option.name || 'Create a New One')
            this.editDialog.settings.visible = true
        },

        editDocument(document) {
            this.editDialog.fields = this.mode == 'Client' ? this.openDocumentFields : this.documentFields
            this.editDialog.record = {...document}

            this.editDialog.settings.title = 'Document'
            this.editDialog.settings.deleteButton = this.mode != 'Client'
            this.editDialog.settings.visible = true
        },


        policiesForCategory(category) {
            return (this.policies || []).filter(o => o.category == category.name)
        },
        optionsForPolicy(policy) {
            return (this.options || []).filter(o => o.policyKey == policy.meta.key).sort(OrderHelpers.sortByOrder)
        },
        firstOptionForPolicy(policy) {
            if(this.optionsForPolicy(policy) && this.optionsForPolicy(policy).length) {
                return this.optionsForPolicy(policy)[0]
            } else
                return {meta:{}}
        },
        remainingOptionsForPolicy(policy) {
            if(this.optionsForPolicy(policy) && this.optionsForPolicy(policy).length > 1) {
                let arr = [...this.optionsForPolicy(policy)]
                arr.shift()
                return arr
            } else
                return []
        },

        documentsForOption(option) {
            return (this.documents || []).filter(o => o.optionKey == option.meta.key)
        },

        saveRecord(item) {
            if(item.optionKey && this.mode != 'Template') {
                ChecklistHelpers.fetchPolicyForDocument(item).then(policy => {
                    policy.modified = true
                    
                    NiceData.saveItem(policy)
                })
            }

            NiceData.saveItem(item)
            this.$emit('change', item)
            this.updateSummary
        },
        deleteRecord(item) {
            NiceData.deleteItem(item)
            this.editDialog.settings.visible = false
        },

        async deleteDocument(document) {
            if(await this.$root.$confirm('Delete', 'Delete this document?', { color: 'red' }) == true) {
                NiceData.deleteItem(document)
            }
        },

        async deleteOption(option) {
            if(await this.$root.$confirm('Delete', 'Delete this option?', { color: 'red' }) == true) {
                NiceData.deleteItem(option)
            }
        },
  
        async deletePolicy(policy) {
            if(await this.$root.$confirm('Delete', 'Delete this policy?', { color: 'red' }) == true) {
                ChecklistHelpers.deletePolicyCascade(policy)
            }
        },

        async deleteCategory(category) {
            if(await this.$root.$confirm('Delete', 'Delete this category?', { color: 'red' }) == true) {
                NiceData.deleteItem(category)
            }
        },

        optionLinkClicked(option) {
            let order = 0 - OrderHelpers.orderKey()
            option.order = order
            NiceData.saveItem(option)
        },
        
        sortCategories() {
            this.sortDialog.items = null
            this.sortDialog.dataRef = this.categoriesRef
            this.sortDialog.settings.visible = true
        },

        sortPoliciesForCategory(category) {
            this.sortDialog.items = this.policiesForCategory(category)
            this.sortDialog.dataRef = this.policiesRef
            this.sortDialog.settings.visible = true
        },
 
        sortOptionsForPolicy(policy) {
            this.sortDialog.items = this.optionsForPolicy(policy)
            this.sortDialog.dataRef = this.optionsRef
            this.sortDialog.settings.visible = true
        },

        sortDocumentsForOption(option) {
            this.sortDialog.items = this.documentsForOption(option)
            this.sortDialog.dataRef = this.documentsRef
            this.sortDialog.settings.visible = true
        },

        initialise() {
            this.loadCategories()
            this.loadPolicies()
            this.loadOptions()
            this.loadDocuments()
        },

        updateSummary() {
            
        }

    },

    watch: {
        'checklistKey': {
            handler: function(newVal, oldVal) {
                this.initialise()
            },
            immediate: true
        },
        'summary': {
            handler: function(newVal, oldVal) {
                PageHelpers.setPageData('summary', newVal)
            },
            immediate: true
        }
    },

    created() {
        //see watcher
    }
}
</script>

<style scoped>
.heading-large {
    font-size: 25px;
    color: #777;
}
.policy {
    padding:5px;
    border: solid 1px #ccc;
    border-radius: 8px;
}
</style>




// WEBPACK FOOTER //
// ChecklistDetails.vue?21020a22